<script>
export default {

    layout: 'layout-guest',

}
</script>

<template>
    <div class="text-center">
        <h4 class="text-danger">{{ $t('GENERAL.NOTFOUND') }}</h4>
    </div>
</template>


// WEBPACK FOOTER //
// src/pages/NotFound.vue